import React, { useState, useRef, ChangeEvent } from 'react';
import { SUPPORTED_FILE_TYPES } from '@dreamai/types';
import { ReactComponent as PlusIcon } from '../../../icons/plus.svg';
import './direct-file-uploader.scss';
import { useFileUpload } from './useFileUpload';
import { FileUploadState } from './types';

export type { FileUploadState };

interface DirectFileUploaderProps {
  onFileUpload: (fileState: FileUploadState) => void;
  disabled?: boolean;
}

export const DirectFileUploader: React.FC<DirectFileUploaderProps> = ({
  onFileUpload,
  disabled = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);
  const { processFile } = useFileUpload(onFileUpload);

  const handleFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setIsUploading(true);

    // Process each file
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      await processFile(file);
    }

    setIsUploading(false);

    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className='file-upload-container'>
      <input
        type='file'
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={SUPPORTED_FILE_TYPES.join(',')}
        className='file-input'
        style={{ display: 'none' }}
        multiple
      />
      <button
        type='button'
        className='file-upload-button'
        onClick={handleFileSelect}
        disabled={disabled || isUploading}
      >
        <PlusIcon /> Add files or images
      </button>
    </div>
  );
};
